// extracted by mini-css-extract-plugin
export default {"overviewVars":"Overview_overviewVars__wfr3C","bottomLeft":"Overview_bottomLeft__PhtWC","subSection":"Overview_subSection__RIcSM","learnMore":"Overview_learnMore__KBirQ"};